export default __webpack_public_path__ + "static/media/hydr_drt2.9f916558.png";